import React from "react";
import { Paper, Typography, Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  paper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: 32,
    height: 420,
    position: "relative",
    borderRadius: 12,
    boxShadow: "0 0 50px 0 rgba(175, 175, 175, 0.4)",
    transition: "box-shadow 500ms ease, transform 500ms ease",
    "&:hover": {
      transform: "scale(1.1)",
      boxShadow: "0 0 50px 0 rgba(175, 175, 175, 0.4)"
    }
  },
  description: {
    marginTop: 32,
    fontSize: 16,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "initial"
  },
  avatar: {
    width: 100,
    height: 100,
    margin: 16
  },
  author: {
    position: "absolute",
    bottom: 16,
    right: 32,
    fontSize: 14,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#3e3e53"
  }
});

export default function TestimonyCard({ author, avatar, description }) {
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.paper}>
      <Avatar src={avatar} className={classes.avatar} />
      <Typography variant="body1" className={classes.description}>
        {description}
      </Typography>
      <Typography variant="body2" className={classes.author}>
        - {author}
      </Typography>
    </Paper>
  );
}
